export default "__VITE_ASSET__C8to33WS__"